// Client\client-vite\src\pages\Lenders\LendersPage.tsx

export const LendersPage = () => {
    return (
        <div>LendersPage</div>
    )
}

export default LendersPage